import { isLockedItem, type CanvasItem } from "@bedrock/domain";

export function withoutCanvasAssetUrl(item: CanvasItem): CanvasItem {
  if (item.props.kind === "image" || item.props.kind === "video" || item.props.kind === "pdf" || item.props.kind === "spreadsheet") {
    const { localUrl: _localUrl, ...props } = item.props;
    return { ...item, props };
  }
  if (item.props.kind === "web-clip") {
    const { previewUrl: _previewUrl, ...props } = item.props;
    return { ...item, props };
  }
  return item;
}

export function withoutStaleCanvasObjectUrl(item: CanvasItem): CanvasItem {
  const url = item.props.kind === "image" || item.props.kind === "video" || item.props.kind === "pdf" || item.props.kind === "spreadsheet"
    ? item.props.localUrl
    : item.props.kind === "web-clip"
      ? item.props.previewUrl
      : undefined;
  return url?.startsWith("blob:") ? withoutCanvasAssetUrl(item) : item;
}

export function canvasAssetId(item: CanvasItem): string | null {
  // Sealed bytes are only shown after an open folder decrypts them.
  if (isLockedItem(item)) return null;
  if (item.props.kind === "image" || item.props.kind === "video" || item.props.kind === "pdf" || item.props.kind === "spreadsheet") return item.props.localUrl ? null : item.props.assetId;
  if (item.props.kind === "web-clip") return item.props.previewUrl ? null : item.props.previewAssetId;
  return null;
}

export function withCanvasAssetUrl(item: CanvasItem, localUrl: string): CanvasItem {
  if (item.props.kind === "image" || item.props.kind === "video" || item.props.kind === "pdf" || item.props.kind === "spreadsheet") {
    return { ...item, props: { ...item.props, localUrl } };
  }
  if (item.props.kind === "web-clip") {
    return { ...item, props: { ...item.props, previewUrl: localUrl } };
  }
  return item;
}
